<template>
  <div class="Exportblok3">
    <v-row>
      <!-- <v-btn type="button" @click="download" color="blue white white--text">
        <span class="material-icons">file_download</span>
        {{ $t("muatturun") }} {{ $t("blok3") }}
      </v-btn> -->
      <v-col class="text-right">
        <!-- <v-btn type="button" @click="exportexcelblok3(tokenexport, exportthn,exportbln,exportps,paparnegeriexport)" color="blue white white--text">
            <span class="material-icons">file_download</span>
            {{ $t("muatturun") }} {{ $t("blok3") }}
          </v-btn> -->
            <download-excel
              :data = "papardatablk3"
              type="csv"
              name="blk3.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("blok3") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatablk3"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
          <template v-slot:[`item.SebenarAnggaran`]="{ item }">
            {{ paparsebenaranggaran(item.SebenarAnggaran) }}
          </template>
          <template v-slot:[`item.PuncaPembelian`]="{ item }">
            {{ paparpuncapembelian(item.PuncaPembelian) }}
          </template>
          <template v-slot:[`item.MediumBayaran`]="{ item }">
            {{ paparmediumbayaran(item.MediumBayaran) }}
          </template>
          <template v-slot:[`item.eDagang`]="{ item }">
            <div :class="papareDagang(item.eDagang)['color']">
              {{ papareDagang(item.eDagang)["text"] }}
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from "@/i18n";
import hidServices from "@/services/lookupField";
import axios from "../../plugins/axios";

import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

const lookup = new hidServices();
export default {
  Name: "Exportblok3",
  setup() {},
  props: ["papardatablk3", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    headers: [
       { text: i18n.t("bil"), value: "Bil" },
      { text: i18n.t("hid"), value: "HID" },
      { text: i18n.t("bno"), value: "BNO" },
      { text: i18n.t("pusingan"), value: "P" },
      { text: i18n.t("S"), value: "S" },
      { text: i18n.t("negeri"), value: "NG" },
      { text: i18n.t("dp"), value: "DP" },
      { text: i18n.t("db"), value: "DB" },
      { text: i18n.t("bp"), value: "BP" },
      { text: i18n.t("st"), value: "ST" },
      { text: i18n.t("notk"), value: "NOTK" },
      { text: i18n.t("noir"), value: "NOIR" },
      { text: i18n.t("koditem"), value: "KodItem" },
      { text: i18n.t("rmHQ"), value: "RMHQ" },
      { text: i18n.t("rmNEG"), value: "RMNEG" },
      { text: i18n.t("puncapembelian"), value: "PuncaPembelian" },
      { text: i18n.t("jenisbarang"), value: "JenisBarang" },
      { text: i18n.t("hargasebenar"), value: "SebenarAnggaran" },
      { text: i18n.t("mediumpembayaran"), value: "MediumBayaran" },
      { text: i18n.t("edagang"), value: "eDagang" },
      { text: i18n.t("kuantiti"), value: "Kuantiti" },
      { text: i18n.t("unit"), value: "Unit" },
      //{ text: i18n.t("keteranganunit"), value: "keteranganUnit" },
      { text: i18n.t("keteranganitem"), value: "Keterangan"},
      { text: i18n.t("catatan"), value: "Catatan" },
      { text: i18n.t("tarikh"), value: "Tarikh" },
      { text: i18n.t("minggu"), value: "Minggu" },
     
    ],
  }),
  watch: {
    papardatablk3(){
      this.papardatablk3.forEach(async function (element) {
        if(element['Tarikh']){
          var mydate = new Date(element['Tarikh']);
          
          var date = mydate.getDate() + "-" + (mydate.getMonth()+1) + "-" + mydate.getFullYear();
    
          element['Tarikh'] = date;
  
        }
      
      });
    }
  },
  methods: {
    async exportexcelblok3(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/blk/exportblk3serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    papareDagang(id) {
      let eDagang = "";
      let color = "";
      lookup.getEdagang().forEach(async function (element) {
        if (id === element.id) {
          eDagang = element.desc;
        }
        if (id === "1") {
          color = "deep-orange--text";
        }
      });
      return { text: eDagang, color: color };
    },
    paparpuncapembelian(id) {
      let puncapembelian = "";
      lookup.getPuncapembelian().forEach(async function (element) {
        if (id === element.id) {
          puncapembelian = element.desc;
        }
      });
      return puncapembelian;
    },
    paparsebenaranggaran(id) {
      let sebenaranggaran = "";
      lookup.getHargasebenaranggaran().forEach(async function (element) {
        if (id === element.id) {
          sebenaranggaran = element.desc;
        }
      });
      return sebenaranggaran;
    },
    paparmediumbayaran(id) {
      let mediumpembayaran = "";
      lookup.getMediumpembayaran().forEach(async function (element) {
        if (id === element.id) {
          mediumpembayaran = element.desc;
        }
      });
      return mediumpembayaran;
    },
  },
};
</script>